import React, {ReactElement} from 'react';

import {
  ResponsiveContainer,
  LineChart,
  CartesianGrid,
  XAxis,
  YAxis,
  Tooltip,
  Line
} from 'recharts';

import Spinner from '../Spinner';
import TableEmptyState from './TableEmptyState';

const ItemsSoldChart = ({
  chartStyles,
  data,
  loading,
  height
}: {
  chartStyles: any;
  data: any;
  loading: boolean;
  height?: string;
}): ReactElement => {
  const renderTableContents = () => {
    if (loading) {
      return <Spinner />;
    }
    if (!data?.length) {
      return <TableEmptyState />;
    }
    return (
      <ResponsiveContainer width="99%">
        <LineChart data={data}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="date" />
          <YAxis dataKey="items" axisLine={false} tickLine={false} width={30} />
          <Tooltip animationDuration={chartStyles.animationDuration} />
          <Line
            animationDuration={chartStyles.animationDuration}
            dot={false}
            type={chartStyles.lineType}
            dataKey="items"
            name="Items"
            stroke="#a639b2"
            strokeWidth={chartStyles.strokeWidth}
          />
        </LineChart>
      </ResponsiveContainer>
    );
  };
  return (
    <div className="content-card admin--itemsSold" style={{height}}>
      <small>Items sold over time</small>
      <div className="center-content">{renderTableContents()}</div>
    </div>
  );
};

ItemsSoldChart.defaultProps = {
  height: '100%'
};

export default ItemsSoldChart;
